import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { getUser } from '~src/user';
import { addWatermark, cleanBase64 } from '../utils';
import Swal from 'sweetalert2';
import JSZip from 'jszip';
import { getSelectedPagesByUser } from './getSelectedPagesByUser';
import { getImageFromPage } from './getImageFromPage';
import { saveSelectedPageImage } from './saveSelectedPageImage';
import { saveAs } from 'file-saver';

export const saveJPEG = async () => {
  const { user } = await getUser();
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }`
  );

  const numberOfPages = selectedPagesByUser.length;

  if (numberOfPages === 1) {
    await saveSelectedPageImage({
      page: selectedPagesByUser[0],
      imageFormat: 'jpeg',
      fileName: fileName + '.jpg',
      withWatermark: user.org_pointer.tipo_istanza === 'demo',
    });
    return;
  }

  const zip = new JSZip();
  const folder = zip.folder('Cartella ' + fileName);

  let pageNumber = 0;
  for (let page of selectedPagesByUser) {
    pageNumber++;

    let image = await getImageFromPage(page);

    if (user.org_pointer.tipo_istanza === 'demo') {
      Swal.fire({
        text: 'Sto generando la cartella zip...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      image = await addWatermark(image);
      const base64Cleaned = cleanBase64(image);
      image = base64Cleaned.base64;
    }

    folder.file(`Pagina ${pageNumber}.jpg`, image, { base64: true });
  }
  const content = await zip.generateAsync({ type: 'blob' });
  saveAs(content, fileName + '.zip');

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: 'La cartella zip &egrave; stata scaricata.',
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
